import { useRouteError } from 'react-router-dom';
import styles from './error-page.module.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className={styles.error_wrapper}>
      <div className={styles.error_content}>
        <h1>Ой!</h1>
        <p>Вибачте, сталася неочікувана помилка.</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </div>
    </div>
  );
}
